import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Plantage pendant l'affichage → message lisible + bouton « Recharger » au lieu d'un écran blanc
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("Campus LCA — plantage :", error, info); }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const detail = `${error && (error.stack || error.message || String(error))}\n\n${navigator.userAgent}\n${window.location.href}`;
    return (
      <div style={{ fontFamily: "-apple-system,'Segoe UI',sans-serif", padding: "32px 20px", color: "#1a2f5a", maxWidth: 430, margin: "0 auto" }}>
        <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>Campus LCA a rencontré une erreur</div>
        <div style={{ fontSize: 14, color: "#64748b", marginBottom: 14 }}>Fais une capture de cet écran et envoie-la à Jérôme.</div>
        <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 11, background: "#f1f5f9", borderRadius: 10, padding: 12, margin: "0 0 16px", maxHeight: 320, overflow: "auto" }}>{detail}</pre>
        <button onClick={() => { try { window.history.replaceState(null, "", "/"); } catch (e) {} window.location.reload(); }}
          style={{ width: "100%", padding: 14, background: "#f97316", color: "#fff", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 800 }}>
          Recharger
        </button>
      </div>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
